import { useUsersMap } from '@components/ArtBoard/Threads'
import { useShowResolved } from '@components/ArtBoard/ThreadsSidebar'
import type { ID } from '@octopus-do/octopus-project-core'
import { selectRelatedThreads } from '@store/reducers/threads'
import { selectSelectedThread } from '@storeOld/reducers/canvas/canvas'
import { shallowEqual, useSelector } from 'react-redux'

export const useThreadsList = (target: ID) => {
  const { showResolved } = useShowResolved()
  const selected = useSelector(selectSelectedThread)
  const threads = useSelector(
    selectRelatedThreads(target, showResolved, selected),
    shallowEqual
  )

  const users = useUsersMap()

  return { threads, selected, users }
}
